export type GamePhase = "countdown" | "running" | "finished";

export interface GameState {
  phase: GamePhase;
  countdownStart: number;
  runStart: number;
  finishTime: number;
}

export const COUNTDOWN_DURATION = 3.5;

export function createGameState(): GameState {
  return {
    phase: "countdown",
    countdownStart: performance.now(),
    runStart: 0,
    finishTime: 0
  };
}

export function startCountdown(state: GameState): void {
  state.phase = "countdown";
  state.countdownStart = performance.now();
  state.runStart = 0;
  state.finishTime = 0;
}
